import { FC, PropsWithChildren } from 'react';
import { cn } from '@/shared/lib/utils';

type Props = {
  role?: string;
  className?: string;
  classNames?: {
    /** Класс подписи роли; переопределяет умолчание её размера */
    role?: string;
  };
};

/**
 * Компонент для отображения заголовка сообщения (автор и роль)
 */
export const ChatMessageTitle: FC<PropsWithChildren<Props>> = ({ children, role, className, classNames }) => {
  if (!children && !role) {
    return null;
  }

  return (
    <div className={cn('flex items-center gap-2 text-sm mr-auto mb-2', className)}>
      {children && <span className={cn('')}>{children}</span>}
      {role && (
        <>
          <div className={cn('rounded size-1')} />
          <span className={cn('text-xs', classNames?.role)}>{role}</span>
        </>
      )}
    </div>
  );
};
